module.exports = __webpack_public_path__ + "img/es-pc-s6.5ab78a89.png";